// extracted by mini-css-extract-plugin
export default {"btnOption":"FeedbackOptions_btnOption__EBC75","divFeedback":"FeedbackOptions_divFeedback__1Y-WW"};